import type { FullyKiosk } from '#x1-base/types'

declare global {
    interface Window {
        fully: FullyKiosk;
        fObj: FullyKiosk;
    }
}

const fullyDummy = new Proxy(new Function, {
    apply: function(target, thisArg, argumentsList) {
        return null;
    },
    set: (target, prop, newValue, receiver) => {
        return true;
    },
    get: (target, prop, receiver) => {
        return receiver;
    }
}) as unknown as FullyKiosk;

export function getFullyObj(): FullyKiosk {
    return (import.meta.client && 'fully' in window) ? window.fully : fullyDummy;
}

export class FullyGlobal extends EventTarget {
    bind(eventName: string, ...args: any) {
        this.dispatchEvent(new CustomEvent(eventName, { detail: args }));
    }
}

export function useFullyKiosk() {
    const fObj = getFullyObj();

    // Exposed Globals
    if (import.meta.client) {
        window.fObj = fObj;
    }

    return fObj;
}
